export enum ResultsTypes {
  Unknown = 'Unknown',
  Confirmed = 'Confirmed',
  Declined = 'Declined',
  Rescheduled = 'Rescheduled',
  ClinicCancelled = 'ClinicCancelled',
  ClinicRescheduled = 'ClinicRescheduled',
}

export enum StatusTypes {
  Unknown = 'Unknown',
  ErrorTimeout = 'ErrorTimeout',
  ErrorBusy = 'ErrorBusy',
  ErrorForbidden = 'ErrorForbidden',
  ErrorOther = 'ErrorOther',
  ErrorRecognize = 'ErrorRecognize',
  ErrorPaketLoss = 'ErrorPaketLoss',
  ErrorHangUp = 'ErrorHangUp',
  Connected = 'Connected',
  RedirectToOperator = 'RedirectToOperator',
  CallFinishedNormally = 'CallFinishedNormally',
  CallFinishedWithTimeout = 'CallFinishedWithTimeout',
  SynchronizationError = 'SynchronizationError',
}

export interface AudioSrc {
  [key: string]: string;
}

declare type EventValue<DateType> = DateType | null;
export declare type RangeValue<DateType> =
  | [EventValue<DateType>, EventValue<DateType>]
  | null;
